import { IonContent } from "@ionic/react";
import type { FC } from "react";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import {
  ANDROID_APP_DOWNLOAD_LINK,
  IOS_APP_DOWNLOAD_LINK
} from "src/constants/misc";
import translate from "src/lib/translate";
import Footer from "src/ui/components/Footer/Footer";
import Translate from "src/ui/components/Translate/Translate";
import { cmsImageUrl } from "src/lib/cmsImageUrl";

import AppDownloadHeroContent from "./AppDownloadHeroContent";

const AppDownloadPage: FC = () => {
  const [contentVisible, setContentVisible] = useState(false);

  const getPlatform = (): "android" | "ios" | "other" => {
    const ua = navigator.userAgent.toLowerCase();
    if (/android/.test(ua)) {
      return "android";
    }
    if (/applewebkit/.test(ua)) {
      return "ios";
    }
    return "other";
  };

  useEffect(() => {
    if (getPlatform() === "android") {
      window.location.replace(ANDROID_APP_DOWNLOAD_LINK);
    } else if (getPlatform() === "ios") {
      window.location.replace(IOS_APP_DOWNLOAD_LINK);
    }

    const timeout = setTimeout(() => {
      setContentVisible(true);
    }, 1000);

    return () => clearTimeout(timeout);
  }, []);

  const appDownloadImgLink = cmsImageUrl(
    "fc651383ca2ba520d8352825cb70bf3035a1c571-1122x1120.png"
  );

  return (
    <IonContent scrollEvents>
      {contentVisible && (
        <div>
          <nine-navigation only-logo>
            <div slot="actions">
              <Link to="/">
                <Translate msg="signin" />
              </Link>
            </div>
          </nine-navigation>

          <main>
            <nine-hero
              keep-img-ratio
              image={appDownloadImgLink}
              variant="split"
              textAlign="left"
              style={{ maxWidth: "1200px", margin: "0 auto" }}
            >
              <div slot="title">
                <AppDownloadHeroContent />
              </div>
            </nine-hero>
          </main>

          <Footer title={translate("downloadApp.footerTitle")} />
        </div>
      )}
    </IonContent>
  );
};

export default AppDownloadPage;
